export class ElementTransformation {
  private matrix: DOMMatrix;
  private element: HTMLElement;
  constructor(element: HTMLElement) {
    this.element = element;
    this.matrix = this.transformMatrix(element);
  }

  public get zRotation(): number {
    return -Math.atan2(this.matrix.m21, this.matrix.m22) * (180 / Math.PI);
  }


  public rotateY(degrees: number) {
    this.matrix.rotateSelf(0, degrees, 0);
  }

  public updateWith(element: HTMLElement) {
    this.matrix = this.matrix.multiply(this.transformMatrix(element))
  }

  public multiply(transformation: ElementTransformation) {
    this.matrix = this.matrix.multiply(transformation.matrix);
  }

  public invert() {
    this.matrix.invertSelf();
  }

  public transformPoint(point: DOMPoint) {
    return point.matrixTransform(this.matrix)
  }

  private transformMatrix(element: HTMLElement) {
    return new DOMMatrix(getComputedStyle(element).transform);
  }

  public get cssString() {
    return this.matrix.toString();
  }

}